module.exports = __webpack_public_path__ + "static/media/teeth-sprites.8ef1ed06.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/teeth-sprites.svg
// module id = 975
// module chunks = 0